/* eslint-disable max-len */
import {
  Button, Modal, Pagination, Space, Table,
  message,
} from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getAdminUsersService, deleteAdminUserService } from '../../services/adminUsersService';
import { adminUserColumns } from '../../../../utils/tableColumns';
import useTranslation from '../../../hooks/translation/useTranslation';

function AdminUser() {
  const { trans } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  const fetchData = async (page) => {
    const res = await getAdminUsersService({ page: page || 1 });
    if (res?.data) {
      setData(res);
    }
  };

  const deleteType = async (id) => {
    try {
      await deleteAdminUserService(id);
      message.success(trans('user_successfully_deleted'));
      fetchData();
    } catch (error) {
      message.error(trans('error_deleting_user'));
    }
  };

  const checkIfDelete = (id, name) => {
    Modal.confirm({
      title: trans('delete_user'),
      content: `თქვენ ნამდვილად გსურთ, რომ ${name} წაშალოთ?`,
      okText: trans('yes'),
      onOk: () => deleteType(id),
      cancelText: trans('no'),
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <Button type="primary" onClick={() => navigate('/admin/users/add')}>
        {trans('add_admin_panel_user')}
      </Button>
      <div className="overflow-table">
        <Space size="large" direction="vertical" style={{ width: '100%' }}>
          <Table
            pagination={false}
            columns={adminUserColumns.map(
              (col) => ({
                ...col,
                title: trans(col.title),
              }),
            )}
            dataSource={data?.data && data?.data?.map((item) => ({
              key: item.id,
              username: item?.username,
              role: item?.role,
              edit: (
                <Button
                  onClick={() => navigate(`/admin/users/${item.id}/edit`)}
                >
                  {trans('edit')}
                </Button>
              ),
              delete: (
                <Button
                  type="danger"
                  onClick={() => checkIfDelete(item?.id, item?.username)}
                >
                  {trans('delete')}
                </Button>
              ),
            }))}
          />
          {data?.meta && (
          <Pagination
            total={data?.meta.totalItems}
            pageSize={data?.meta.itemsPerPage}
            current={data?.meta?.currentPage ? +data.meta.currentPage : 1}
            onChange={(e) => fetchData(e)}
          />
          )}
        </Space>
      </div>
    </Space>
  );
}

export default AdminUser;
